import React from 'react';
import { translate } from 'react-i18next';
import {
  ModalMobileLayout,
  Text,
  Box,
  Button,
  FormField,
  InputArea,
} from 'wix-style-react';
import ReviewItemMobile from '../ReviewItem/ReviewItemMobile';
import s from './replyReviewModalLayout.scss';

const ReplyReviewModalLayoutMobile = ({
  t,
  closeReplyModal,
  replyToReview,
  disableReplyButton,
  selectedReview,
  onInputAreaChange,
}) => {
  return (
    <ModalMobileLayout
      dataHook="reply-to-review-modal-layout-mobile"
      className={s.replyToReviewModalMobile}
      title={
        <div>
          <Text
            weight="bold"
            size="medium"
            tagName="div"
            style={{ marginBottom: '12px' }}
          >
            {t('expert-replyreview-title')}
          </Text>
          <Text size="small">{t('expert-replyreview-description')}</Text>
        </div>
      }
      fullscreen
      onCloseButtonClick={closeReplyModal}
      content={
        <div>
          <ReviewItemMobile review={selectedReview} reviewInModal={true} />
          <div className={s.replyReviewModalReviewWrapper}>
            <div className={s.replyReviewModalFormFieldWrapper}>
              <FormField
                label={
                  <Text size="small" weight="thin">
                    {t('expert-replyreview-fieldtitle')}
                  </Text>
                }
              >
                <InputArea
                  dataHook="reply-to-review-input-area"
                  size="small"
                  hasCounter={true}
                  maxLength={500}
                  minHeight="230px"
                  maxHeight="230px"
                  rows={4}
                  onChange={onInputAreaChange}
                  placeholder={t('expert-replyreview-placeholder')}
                />
              </FormField>
            </div>
          </div>
        </div>
      }
      footer={
        <Box align="right">
          <Box marginRight="12px">
            <Button priority="secondary" size="small" onClick={closeReplyModal}>
              {t('expert-replyreview-ctacancel')}
            </Button>
          </Box>
          <Button
            size="small"
            disabled={disableReplyButton}
            onClick={replyToReview}
          >
            {t('expert-replyreview-ctabutton')}
          </Button>
        </Box>
      }
      stickyFooter
    />
  );
};

export default translate()(ReplyReviewModalLayoutMobile);
